import { MapperBase } from '../../utilities/mapper-base';
import { PublicFileResource } from '../resource/public-file.resource';
import { FileRecord } from '../ui/file.model';
import { FileTypeResourceToFileTypeMapper } from './file-type-resource-to-file-type.mapper';
import { FormattingUtility } from '../../utilities/formatting.utility';

const fileTypeResourceToFileTypeMapper = new FileTypeResourceToFileTypeMapper();

export class PublicFileResourceToFileMapper extends MapperBase<PublicFileResource, FileRecord> {
	map(source: PublicFileResource): FileRecord {

		const dest = new FileRecord();
		dest.id = source.fileId;
		dest.type = fileTypeResourceToFileTypeMapper.map(source.type);
		dest.name = source.fileName;
		dest.size = FormattingUtility.bytesAsFriendly(source?.size);
		dest.lifeCycle = source.lifeCycle;
		return dest;
	}
}
